import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";
import utilityVariables from "ui-v2/styles/utility_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue =
    semanticVariables?.[`semantic_icon_${color}`] ||
    utilityVariables?.[`utility_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M9.13468 7.13248L9.48745 5.0926C9.57556 4.5831 9.18375 4.1171 8.66726 4.1171H6.07672C5.81997 4.1171 5.62445 3.88664 5.66601 3.63299L5.99735 1.61071C6.05118 1.28217 6.0358 0.946 5.95221 0.623762C5.88297 0.35682 5.67701 0.142475 5.40616 0.0554625L5.33367 0.0321771C5.16997 -0.0204102 4.99131 -0.00817303 4.83697 0.0661966C4.6671 0.148056 4.54282 0.297367 4.49675 0.474944L4.2589 1.39187C4.18322 1.68362 4.07298 1.96523 3.93085 2.23131C3.72317 2.62009 3.40208 2.93123 3.06831 3.21885L2.34894 3.83874C2.14612 4.01353 2.0396 4.27528 2.06268 4.5422L2.46876 9.23854C2.50601 9.66931 2.86616 10 3.29805 10H5.62236C7.363 10 8.84852 8.7872 9.13468 7.13248Z"
        fill={colorValue}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.483833 3.74254C0.684465 3.73388 0.856306 3.88481 0.873606 4.08488L1.35941 9.70314C1.39061 10.064 1.10634 10.3751 0.743353 10.3751C0.401445 10.3751 0.125 10.0977 0.125 9.75646V4.11719C0.125 3.91637 0.2832 3.75119 0.483833 3.74254Z"
        fill={colorValue}
      />
    </svg>
  );
};
